// Servizio di geocoding per convertire indirizzi in coordinate
// Usa OpenStreetMap Nominatim API (gratuita)

const GEOCODING_BASE_URL = 'https://nominatim.openstreetmap.org/search';

export const geocodeAddress = async (address) => {
  if (!address || address.trim() === '') {
    return null;
  }

  try {
    const params = new URLSearchParams({
      q: address,
      format: 'json',
      limit: 1,
      countrycodes: 'it', // Limita la ricerca all'Italia
      addressdetails: 1
    });

    const response = await fetch(`${GEOCODING_BASE_URL}?${params}`, {
      headers: {
        'User-Agent': 'RentalApp/1.0' // Nominatim richiede un User-Agent
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    if (data && data.length > 0) {
      const result = data[0];
      return {
        address: result.display_name,
        latitude: parseFloat(result.lat),
        longitude: parseFloat(result.lon),
        confidence: result.importance || 0
      };
    }
    
    return null;
  } catch (error) {
    console.error('Errore nel geocoding:', error);
    return null;
  }
};

// Funzione per geocodificare un indirizzo e aggiornare i campi del form
export const geocodeAndUpdateForm = async (address, setFormData) => {
  if (!address || address.trim() === '') {
    return;
  }

  const result = await geocodeAddress(address);
  
  if (result) {
    setFormData(prev => ({
      ...prev,
      location: result.address,
      latitude: result.latitude,
      longitude: result.longitude
    }));
    return result;
  } else {
    // Se il geocoding fallisce, mantieni l'indirizzo ma azzera le coordinate
    setFormData(prev => ({
      ...prev,
      latitude: null,
      longitude: null
    }));
    return null;
  }
};

// Funzione per geocodificare tutti i veicoli che hanno solo l'indirizzo
export const geocodeVehicles = async (vehicles) => {
  const geocodedVehicles = [];
  
  for (const vehicle of vehicles) {
    if (vehicle.location && (!vehicle.latitude || !vehicle.longitude)) {
      const result = await geocodeAddress(vehicle.location);
      if (result) {
        geocodedVehicles.push({
          ...vehicle,
          latitude: result.latitude,
          longitude: result.longitude
        });
      } else {
        geocodedVehicles.push(vehicle);
      }
    } else {
      geocodedVehicles.push(vehicle);
    }
  }
  
  return geocodedVehicles;
};
